module.exports = __webpack_public_path__ + "fonts/helveticaneueltpro-roman-webfont.31a2653c.woff2";